<app-navbar></app-navbar>

<div class="container-fluid course-page">
  <div class="row">
    <nav class="col-md-3 col-lg-2 d-md-block sidebar course-sidebar">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" routerLink="/electric-cars">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Electric Cars</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/design-and-manufacturing">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Design and Manufacturing</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/auto-electrical">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Auto Electrical of an Electric Scooter</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/iot">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Internet of Things</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/charger-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Charger Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" routerLink="/solar-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Solar Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/welding">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Welding</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <main role="main" class="col-md-9 col-lg-10 ms-sm-auto px-3 px-md-4 py-4 course-content">
      <section class="course-header">
        <p class="course-tag">FEA Course</p>
        <h1>FEA- Solar Installation</h1>
        <p class="course-subtitle">Learn through guided lessons and complete the module resources and progress checkpoints.</p>
      </section>

      <section class="lesson-grid">
        <article class="lesson-card">
          <h4><span>01</span> Solar Installation Part 1</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FSolar-Installation-Blessings%2FBlessings%20(Solar%20Installation).mp4?alt=media&token=1cd4d5db-daac-4ba2-b5ad-de345d79fd29" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>02</span> Solar Installation Part 2</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FSolar-Installation-Blessings%2FBlessings%20(Solar%20Installation%201).mp4?alt=media&token=a9e82aaf-a607-402e-9aba-e084e66b6121" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>03</span> Applications of Energy</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FSolar-Installation-Blessings%2FBlessings%20(Applications%20Of%20Energy).mp4?alt=media&token=c73ee5a1-7f8d-417d-858b-de8fd921e15c" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>04</span> Lesson 04</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FSolar-Power-Design%2FSFEA_Intro_fin_Gifty%204.mp4?alt=media&token=678e68c9-ebe8-40dd-b4ae-738e5be75d6e" type="video/mp4">
          </video>
        </article>

      </section>

      <section class="course-actions">
        <a class="btn solarorange" href="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FSolar-Installation-Blessings%2FCHARGER%20INSTALLATION%20-%20SOLAR%20INSTALLATION%20FINAL.pptx?alt=media&token=4c5324e8-3cf0-434d-a2b1-5ecf12aa219f" target="_blank" rel="noopener noreferrer">
          Download Course Material
        </a>

        <a class="btn solarblue" href="https://forms.gle/nNidS4SiZp1qrrJY6" target="_blank" rel="noopener noreferrer">
          Take Assessment
        </a>

        <button type="button" class="btn solarorange complete-btn" (click)="completed()">
          Mark Completed
        </button>
      </section>
    </main>
  </div>
</div>
